/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as isWebCn, i as isWebAp, b as isWebTb } from '../../index-f24a9ec1.js';
import onBackCatcher$1 from './cn/index.js';
import onBackCatcher$3 from './tb/index.js';
import onBackCatcher$2 from './ap/index.js';
import '../../bridges/windvane/index.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../tslib.es6-e01eabb2.js';

/**
 * 原生容器，默认返回时的拦截和回调监听
 * 注意该方法只能拦截原生容器（Android/IOS）返回，navigateBack无法拦截。
 * @param cb 拦截返回回调函数
 * @returns 返回取消对用户返回的拦截
 * @example 使用案例：
 * import { onBackCatcher } from '@alife/cn-uni-api';
 *
 * useEffect(() => {
 *  const callback = () => {}
 *  const cancelBackCatcher = onBackCatcher(callback);
 *
 *  return () => cancelBackCatcher();
 * }, [])
 */
var onBackCatcher = function (cb) {
    if (isWebCn) {
        return onBackCatcher$1(cb);
    }
    if (isWebAp) {
        return onBackCatcher$2(cb);
    }
    if (isWebTb) {
        return onBackCatcher$3(cb);
    }
    console.warn('onBackCatcher API is not support this env');
    return function () { };
};

export { onBackCatcher };
